import styled from 'styled-components';

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
`;
